import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";
import { environment } from "../../environments/environment";

@Component({
  selector: "app-thankyou",
  templateUrl: "./thankyou.component.html",
})
export class ThankyouComponent implements OnInit {
  validationMessage: any;
  path: any;
  selectedlang: any;
  couldFrontURL = environment.cloudFrontURL;
  scheduleappointmentid: any = "";
  constructor(
    private appservice: AppService,
    private datepipe: DatePipe,
    private router: Router
  ) {}

  ngOnInit() {
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length == 3) {
      this.scheduleappointmentid = Splitpath[2];
    }
    this.getLanguage();
    this.getscheduleappointmentId();
  }
  redirect() {
    this.router.navigate(["/home"]);
  }

  getscheduleappointmentId() {
    this.viewpatient();
  }
  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"] && res["validationMessage"])
        this.validationMessage = res["validationMessage"];
      this.selectedlang = res["commonMsg"];
    });
  }
  scheduledpatient: any = {};
  scheduleDateShow: any;
  lat: number;
  lng: number;
  viewpatient() {
    this.appservice
      .viewscheduleappointment(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.scheduledpatient = res["entity"];
            this.lat = +this.scheduledpatient.latitude;
            this.lng = +this.scheduledpatient.longitude;
            this.scheduleDateShow = this.datepipe.transform(
              this.scheduledpatient.scheduledOn,
              "MMM d, y"
            );
          }
        } else {
          this.router.navigate(["/home"]);
        }
      }, (err) => {});
  }
}
